import gql from "graphql-tag";

export default {
  events: gql`
    query Events {
      events(first: 10000) {
        edges {
          node {
            id
            _id
            name
          }
        }
      }
    }
  `,
};
